'use client';

import React from 'react';
import { Chip, Tooltip } from 'src/components';
import type { AccessTag } from '../../types';

interface AccessTagsProps {
  tags: AccessTag[];
}

/**
 * @description Renders a user's roles and permission flags as chips. An empty
 *              set renders an em dash so the cell never looks like missing data.
 * @returns React.ReactElement
 */
const AccessTags: React.FC<AccessTagsProps> = ({ tags }) => {
  if (!tags?.length) {
    return (
      <span className="text-neutral-500" data-testid="access-tags-empty">
        —<span className="sr-only">No roles assigned</span>
      </span>
    );
  }

  return (
    <div className="flex flex-wrap gap-1" data-testid="access-tags">
      {tags.map((tag) => (
        <Tooltip key={tag.label} content={tag.tooltip} delay={200}>
          <Chip size="sm" variant="soft" color={tag.color}>
            {tag.label}
          </Chip>
        </Tooltip>
      ))}
    </div>
  );
};

export default AccessTags;
